import { useTranslation } from 'react-i18next';

import { PortfolioListSection } from '../components/PortfolioListSection';

import portfolioImg from '@/assets/portfolio_illustration.svg';

export const Portfolio = () => {
  const { t } = useTranslation('portfolio');

  return (
    <>
      <div className="section">
        <h1 className="section-title flex justify-self-center whitespace-pre-line">{t('title')}</h1>

        <div className="flex justify-center mt-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:w-4/6">
            <div className="col-span-2">
              <div className="section-content">{t('subtitle')}</div>
            </div>
            <div className="flex justify-center items-center">
              <img
                src={portfolioImg}
                alt={t('portfolio')}
                className="h-[50v] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <PortfolioListSection />
    </>
  );
};
